import { useCallback, useEffect, useState } from 'react'
import { SocioeducationMeasureIdentificationType } from 'types/socioeducation-measure-identification.type'
import client from 'services/client'
import { BaseData } from 'types/base.type'
import { useBackdrop } from 'contexts/backdrop.context'
import { HttpErrorType } from 'types/http.type'
import { errorColor, errorMessage } from 'utils/error.util'
import { useSnackBar } from 'contexts/snackbar.context'
import { SystemMessages } from 'utils/enums/system-message.enum'
import { SocioeducationMeasureMeasuresAppliedType } from 'types/socioeducation-measure-measures-applied.type'

export const useMeioAbertoMedidasAplicadas = (id?: string) => {
  const { handleBackdropOpen, handleBackdropClose } = useBackdrop()
  const { showSnackBar } = useSnackBar()

  const [medidasAplicadas, setMedidasAplicadas] =
    useState<SocioeducationMeasureMeasuresAppliedType | null>(null)

  const handleBuscarPorId = useCallback(async () => {
    console.log('id', id)
    if (id) {
      handleBackdropOpen()
      const url = `/meio-aberto/${id}/medidas-aplicadas`
      await client
        .get<BaseData<SocioeducationMeasureMeasuresAppliedType>>(url)
        .then((response) => {
          if (response.data) {
            setMedidasAplicadas(response.data)
          }
        })
        .finally(() => handleBackdropClose())
    }
  }, [id])

  const handleSalvar = async (data?: SocioeducationMeasureMeasuresAppliedType) => {
    if (data) {
      const url = `/meio-aberto/${id}/medidas-aplicadas`

      handleBackdropOpen()
      await client
        .put(url, { ...data })
        .then(async () => {
          await handleBuscarPorId()
          showSnackBar(SystemMessages.MESSAGE_001, 'success')
        })
        .catch((error: HttpErrorType) => showSnackBar(errorMessage(error), errorColor(error)))
        .finally(() => handleBackdropClose())
    }
  }

  useEffect(() => {
    handleBuscarPorId()
  }, [handleBuscarPorId])

  return {
    medidasAplicadas,
    handleBuscarPorId,
    handleSalvar,
  }
}
